/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_Public_ProfileInputs */

const en_view_public_profile = /** @type {(inputs: View_Public_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Public Profile`)
};

/** @type {(inputs: View_Public_ProfileInputs) => LocalizedString} */
const es_view_public_profile = en_view_public_profile;

/** @type {(inputs: View_Public_ProfileInputs) => LocalizedString} */
const fr_view_public_profile = en_view_public_profile;

/** @type {(inputs: View_Public_ProfileInputs) => LocalizedString} */
const de_view_public_profile = en_view_public_profile;

/** @type {(inputs: View_Public_ProfileInputs) => LocalizedString} */
const ja_view_public_profile = en_view_public_profile;

/** @type {(inputs: View_Public_ProfileInputs) => LocalizedString} */
const zh_view_public_profile = en_view_public_profile;

/** @type {(inputs: View_Public_ProfileInputs) => LocalizedString} */
const ar_view_public_profile = en_view_public_profile;

/** @type {(inputs: View_Public_ProfileInputs) => LocalizedString} */
const id_view_public_profile = en_view_public_profile;

/** @type {(inputs: View_Public_ProfileInputs) => LocalizedString} */
const it_view_public_profile = en_view_public_profile;

/** @type {(inputs: View_Public_ProfileInputs) => LocalizedString} */
const ru_view_public_profile = en_view_public_profile;

/** @type {(inputs: View_Public_ProfileInputs) => LocalizedString} */
const pt_view_public_profile = en_view_public_profile;

/** @type {(inputs: View_Public_ProfileInputs) => LocalizedString} */
const ko_view_public_profile = en_view_public_profile;

/**
* | output |
* | --- |
* | "View Public Profile" |
*
* @param {View_Public_ProfileInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const view_public_profile = /** @type {((inputs?: View_Public_ProfileInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_Public_ProfileInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_view_public_profile(inputs)
	if (locale === "es") return es_view_public_profile(inputs)
	if (locale === "fr") return fr_view_public_profile(inputs)
	if (locale === "de") return de_view_public_profile(inputs)
	if (locale === "ja") return ja_view_public_profile(inputs)
	if (locale === "zh") return zh_view_public_profile(inputs)
	if (locale === "ar") return ar_view_public_profile(inputs)
	if (locale === "id") return id_view_public_profile(inputs)
	if (locale === "it") return it_view_public_profile(inputs)
	if (locale === "ru") return ru_view_public_profile(inputs)
	if (locale === "pt") return pt_view_public_profile(inputs)
	return ko_view_public_profile(inputs)
});